import React, { useState } from "react";
import ImageUploader from "./ImageUploader"
import { ToastContainer } from "react-toastify";

const GalleryModal = ({ isOpen, setIsOpen }) => {
    const [text, setText] = useState("");
    const maxChars = 150;

    const handleChange = (e) => {
        if (e.target.value.length <= maxChars) {
            setText(e.target.value);
        }
    };

    if (!isOpen) return null;

    return (
        <>
            <div className="custom-modal-overlay" onClick={() => setIsOpen(false)}>
                <div
                    className="custom-modal-content"
                    onClick={(e) => e.stopPropagation()}
                >
                    <h2 className="oms-modal-title">Gallery</h2>
                    <form className="oms-modal-form">
                        {/* Title Input */}
                        <div className="oms-form-group">
                            <label htmlFor="title" className="oms-form-label">
                                Title
                            </label>
                            <input type="text" id="title" placeholder="Enter title" />
                        </div>

                        <div className="oms-form-group" style={{ position: "relative" }}>
                            <label htmlFor="description" className="oms-form-label">
                                Description
                            </label>
                            <textarea
                                id="description"
                                placeholder="Enter description"
                                value={text}
                                onChange={handleChange}
                                style={{ paddingRight: "50px" }} // Ensures space for counter
                            ></textarea>
                            <div
                                style={{
                                    position: "absolute",
                                    bottom: "5px",
                                    right: "10px",
                                    fontSize: "12px",
                                    color: text.length === maxChars ? "red" : "#666",
                                }}
                            >
                                {text.length}/{maxChars}
                            </div>
                        </div>

                        {/* Featured Image Upload */}
                        <div className="oms-form-group">
                            <label htmlFor="featuredImg" className="oms-form-label">
                                Featured Image
                            </label>
                            <input type="file" id="featuredImg" accept="image/*" />
                        </div>
                        <div className="oms-form-group">
                            <label htmlFor="featuredImg" className="oms-form-label">
                                Gallery images
                            </label>
                            <ImageUploader />
                        </div>
                        <div className="oms-form-actions">
                            <button type="button" onClick={() => setIsOpen(false)}>
                                Cancel
                            </button>
                            <button type="submit">Submit</button>
                        </div>
                    </form>
                </div>
            </div>

            <ToastContainer position="top-right" autoClose={3000} style={{ zIndex: 999999 }} />
        </>
    )
}

export default GalleryModal;